// extracted by mini-css-extract-plugin
module.exports = {"productTitle":"styles_productTitle__cAPik","productTitleMobile":"styles_productTitleMobile__7MJht"};